import React from "react";

import { fetchLicenseStatistics, LicenseStatistics } from "@admin/api/license";

export const useGetLicenseStatistics = () => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [isError, setIsError] = React.useState(false);
    const [data, setData] = React.useState<LicenseStatistics | null>(null);
    const [refreshKey, setRefreshKey] = React.useState(0);

    React.useEffect(() => {
        const controller = new AbortController();
        setIsLoading(true);
        setIsError(false);

        fetchLicenseStatistics(controller.signal)
            .then((result) => {
                if (!controller.signal.aborted) {
                    setData(result);
                }
            })
            .catch(() => {
                if (!controller.signal.aborted) {
                    setIsError(true);
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) {
                    setIsLoading(false);
                }
            });

        return () => controller.abort();
    }, [refreshKey]);

    return { data, isLoading, isError, refetch: () => setRefreshKey((key) => key + 1) };
};
